import TrustPilotLogo from 'assets/images/signUp/trust-pilot.svg';

const TrustPilotCard: React.FC = () => {
  return <img alt="trust pilot rating" src={TrustPilotLogo} />;
};

export default TrustPilotCard;
